<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <my-form
        v-if="formatData"
        ref="overFormRef"
        :data="formatData"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />

      <!-- submit and reset -->
      <b-row>
        <b-col
          v-if="!searchPerformance.includes(formId)"
          cols="12"
          class="my-form_btns"
        >
          <p class="text-secondary">
            {{ explain }}
          </p>
          <b-button variant="primary" :disabled="loading" @click="send">
            {{ $t('_components.btns.send') }}
          </b-button>
          <b-button
            v-if="['2', '40', 2, 40].indexOf(this.formId) == -1"
            variant="outline-primary"
            class="ml-3"
            :disabled="loading"
            @click="saveDrafts"
          >
            {{ $t('_components.btns.saveDrafts') }}
          </b-button>
        </b-col>
        <b-col v-else cols="12" class="my-form_btns">
          <p class="text-secondary">
            {{ explain }}
          </p>
          <b-button variant="primary" :disabled="loading" @click="saveDrafts">
            {{ $t('_components.btns.save') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <component
      :is="flowKey"
      v-else
      :process-key="processKey"
      :explain="explain"
      @cancel="handleCustFormCancel"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import templateFormAPI from '@/api/templateForm/index'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import website from '@/config/website'
import { mapGetters } from 'vuex'
// custForm
import positiveRecordAPI from '@/api/staff/positiveRecord/index'
import TransferProject from './custForm/transferProject.vue'
import Induction from './custForm/induction.vue'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
    TransferProject,
  },
  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    pageId: {
      type: [Number, String],
      default: undefined,
    },
    formId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: () => {},
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        isPass: false,
      },
      fromShow: true,
      pageConfirmationAssessment: [],
      flowKey: '',
      processStatus: '',
      hasDept: false,
      isDrafts: false,
      loading: false,
      columns: [],
      searchPerformance: [101, 102, 103, 104],
    }
  },
  watch: {
    'data.positiveRecordIds': {
      handler(e) {
        console.log(e)
        if (Number(this.formId) === 5) {
          if (e && e.length > 0) {
            console.log(e)
            const staffIds = this.pageConfirmationAssessment
              .filter((item) => e.indexOf(item.id) !== -1)
              .map((item) => item.staffId)
            this.data.staffIds = staffIds || []
          } else {
            this.data.staffIds = []
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    companyId() {
      return (
        this.userAllInfo.staffInfo.companyId ||
        this.userAllInfo.workerInfo.companyId
      )
    },
    option() {
      const option = {
        columns: this.columns,
      }
      return option
    },
    formatData() {
      const { data } = this
      return data || undefined
    },
  },
  created() {
    if (this.processId) {
      this.data = undefined
      this.id = this.processId
      applyAPI.detail({ id: this.processId }).then((res) => {
        const { data } = res.data
        this.processKey = data.processKey
        this.processInstanceId = data.processInstanceId
        this.formId = data.formId
        this.processStatus = data.status
        this.data = data.map || {}
      })
    }
  },
  mounted() {
    console.log(this.processKey, 'processKey')
    if (this.formId) {
      if (Number(this.formId) === 6) {
        this.flowKey = 'Induction'
        this.fromShow = false
      } else if (Number(this.formId) === 35) {
        this.flowKey = 'TransferProject'
        this.fromShow = false
      } else {
        this.onLoad(this.formId)
      }
      if (Number(this.formId) === 5) {
        console.log(this.formId, 'formId')
        applyAPI
          .pageConfirmationAssessment(1, -1, { status: 7 })
          .then((res) => {
            console.log(res)
            this.pageConfirmationAssessment = res.data.data.records
          })
      }
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit')
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    resetForm() {
      this.form = {}
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        const setDictQuery = (item) => {
          const dictQuery = {}
          if (item.dictCode === 'dept') {
            dictQuery.parentId = this.companyId
            this.hasDept = true
          }
          return dictQuery
        }
        this.columns = templateFormat(temp, setDictQuery)
      })
    },
    send() {
      this.isDrafts = false
      this.$refs.overFormRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.overFormRef.validationForm()
    },
    handleSubmit(form) {
      this.loading = true
      const params = templateSubmitFormat(form, this.columns)
      params.processKey = this.processKey
      params.formId = this.formId
      params.processId = this.id
      const router = website.staffProcessRouter

      if (this.hasDept) {
        params.companyId = this.companyId
      }
      const overCallback = () => {
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.loading = false
      }
      if (this.formId === 25999 && !this.isDrafts) {
        // console.log(this.isDrafts)
        // this.loading = false
        params.positiveRecordId = this.pageId
        positiveRecordAPI
          .saveConfirmationAssessment({ variables: params })
          .then((res) => {
            this.$emit('close')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
            this.loading = false
          })
      } else {
        applyAPI.edit(params).then((res) => {
          if (!this.isDrafts) {
            applyAPI.start({ processId: params.processId }).then(() => {
              overCallback()
            })
          } else {
            overCallback()
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-add-form {
  height: 100%;
  position: relative;
  .my-form {
    height: calc(100% - 100px);
    position: relative;
    overflow: hidden;
    &_btns {
      left: 0;
      right: 0;
      position: absolute;
      bottom: 0;
      text-align: center;
      border-top: 1px solid #ebe9f1;
      background: #fff;
      padding: 1.5rem 0;
    }
  }
}
</style>
